import axios from "axios";

const urlPath = "delegation";

export const getDelegationsSupp = async (id) => {
    try {
      const response = await axios.get(`${urlPath}/supp/${id}`);
      console.log(response.data)
      return response.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

//No se usa en el front
// export const getDelegations = async (nif) => {
//     try {
//       const response = await axios.get(`${urlPath}/${nif}`);
//       return response.data;
//     } catch (err) {
//       console.log(err.response);
//       return err.response;
//     }
//   };